import { checkIsSnapshotAvailable, getSnapshot } from '@toloka-tb/request';

import { sessionsManager } from '../modules/sessions/sessionsManager';
import { LZString } from '../utils/lzw';

import { appState, configState, features as defaultFeatures, intl } from './defaults';
import { type GetInitParams } from './getInitParams';

const removeParamsFromUrl = (params: string[]) => {
    const url = new URL(location.href);

    params.forEach((param) => {
        url.searchParams.delete(param);
    });

    history.replaceState(null, '', url.toString());
};

export const getInitParamsStandalone: GetInitParams = async () => {
    const params = new URLSearchParams(location.search.substr(1));
    const configUrlParam = params.get('config');
    const snapshotId = params.get('snapshotId');
    const registryPrereleaseTag = params.get('registryPrereleaseTag') || window.TB_REGISTRY_PRERELEASE_TAG;
    const features = { ...defaultFeatures };

    // features.isAiAssistantAvailable = await checkIsAiAssistantAvailable();
    features.isAiAssistantAvailable = false;
    features.isSnapshotsAvailable = await checkIsSnapshotAvailable();

    if (features.isAiAssistantAvailable) {
        features.panes.assistant = true;
    }

    const configFromStorage = sessionsManager.getConfigWithInput();

    if (configFromStorage) {
        configState.config = configFromStorage.data.config;
        configState.input = configFromStorage.data.input;
    }

    if (snapshotId) {
        try {
            const { snapshotContent } = await getSnapshot(snapshotId);

            if (snapshotContent) {
                const snapshot = JSON.parse(snapshotContent);

                configState.config = snapshot.config;
                configState.input = snapshot.input;

                removeParamsFromUrl(['snapshotId']);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }
    }

    // TODO: remove later to stop supporting config in url
    if (configUrlParam) {
        try {
            const jsonString = LZString.decompressFromEncodedURIComponent(configUrlParam);

            if (jsonString !== null) {
                const decodedHash: {
                    config: string;
                    input: string;
                } = JSON.parse(jsonString);

                configState.config = decodedHash.config;
                configState.input = decodedHash.input;

                // clear "config" params from url
                removeParamsFromUrl(['config']);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }
    }

    return {
        appState,
        features,
        configState,
        intl,
        registryPrereleaseTag
    };
};
